<template>
    <div class="talent_acquisition no-trans" v-loading="loading">
        <div class="talent_acquisition1">
            <div class="talent_acquisition_box1">
                <div class="title_box">
                    <img src="@/assets/img/login/Frame.png" alt="">
                    <router-link class="span1 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/home">首页</router-link> > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/talent_acquisition">人才招聘</router-link> > <span class="span2" aria-current="page">详情</span>
                </div>
                <div class="info_box">
                    <div class="inof_top">
                        <div class="info_top_left">
                            <div class="info_title">{{job_detial.title}}</div>
                            <div class="info_tages">
                                <div class="tages">{{minx_get_province(job_detial.province)}}，中国</div>
                                <div class="borders"></div>
                                <div class="tages">
                                    <!-- {{ job_detial.job_type }} -->

                                    {{ job_detial.job_type==1?'法律实习生':'' }}
                                    {{ job_detial.job_type==2?'法律律师':'' }}
                                    {{ job_detial.job_type==3?'企业法务':'' }}
                                </div>
                                <div class="borders"></div>
                                <div class="tages">{{ job_detial.pub_time }}</div>
                            </div>
                        </div>
                        <div class="info_top_right">
                            <div class="btns" @click="handle_application" v-if="job_detial.if_resume==0">申请岗位</div>
                        </div>
                    </div>
                    <div class="info_bom">
                        <div class="info_bom_title">
                            工作职责
                        </div>
                        <div class="info_bom_const">
                            <div v-html="job_detial.job_respon "></div>
                           <!-- {{ job_detial.job_respon }} -->
                        </div>
                        <div class="info_bom_title">
                            工作要求
                        </div>
                        <div class="info_bom_const">
                          {{job_detial.job_ask}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="talent_acquisition_box2">
                <div class="box2_titles">
                    <div class="title_borders"></div>
                    <div class="title_text">相关岗位推荐</div>
                </div>
                <div class="box2_list">
                    <div class="list_item" v-for="(item,index) in list" :key="index">
                        <div class="item_left">
                            <div class="item_title">{{ item.title }}</div>
                            <div class="item_tages">
                                <div class="tages">
                                    {{minx_get_province(item.province)}}

                                </div>
                                <div class="borders"></div>
                                <!-- <div class="tages">实习生</div> -->
                                <!-- <div class="borders"></div> -->
                                <div class="tages">{{ item.pub_time }}</div>
                            </div>
                            <div class="item_const">
                                {{ item.desc }}
                            </div>
                        </div>
                        <div class="item_right" @click="handle_detial(item)">
                            <div class="btns" >
                                <img src="../../../assets/img/index/talent_acquisition/rights.png" alt="">
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
             
        </div>
        <talent_acquisition ref="talent_acquisition"></talent_acquisition>

    </div>
</template>
<script>
import { useListeners } from 'vue';
import {
    mapState
} from 'vuex'
import talent_acquisition from '@/components/law/talent_acquisition/talent_acquisition.vue'//申请弹窗



export default { 
    components: {
        talent_acquisition
    },
    name: "homes",
    data() {
        return {
            loading: false,
          
            list:[],
            job_detial:[],
        }
    },
    computed: {

    },
    watch: {
        $route(to, from) {
			this.get_list(); 
            this.get_detial()
		}
    },
    created() {
        this.get_list()
        this.get_detial()

    },
    methods: {
        get_list(){
            this.loading=true
            this.$api("jobList", {
                page: 1,
                limit: 3,
                recommend:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('职位列表',res)
                if (res.code == 1) {
                    this.list=res.data.data
                    this.total=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_detial(){
            this.loading=true
            this.$api("jobDetail", {
               id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('职位详情',res)
                if (res.code == 1) {
                   this.job_detial=res.data
                } else {
                    alertErr(res.msg)
                }
            }); 
        },
        handle_detial(item){
			// document.querySelector('#app').scrollTop =0;
            this.$router.push({
                path:'/talent_acquisition_detial',
                query:{
                    id:item.id
                }
                
            })
        },
        handle_application(){
            this.$refs.talent_acquisition.handle_open()
        },
    },

}
</script>
<style scoped lang="less">
.talent_acquisition {
    width: 100%;

    .talent_acquisition1 {
        background-color: #F5F5F5;
        padding-bottom: 50px;

        .talent_acquisition_box1 {

            width: 1440px;
            margin: auto;
            padding-top: 20px;
            padding-bottom: 40px;

            .title_box {
                padding-bottom: 21px;

                display: flex;
                align-items: center;

                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

                .span1 {
                    cursor: pointer;
                    margin-right: 10px;
                }

                .span2 {
                    cursor: pointer;
                    margin-left: 10px;
                }

                img {
                    margin-right: 10px;
                }
            }
            .info_box{
                width: 1440px;
                height: 826px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                padding: 40px;
                .inof_top{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    padding-bottom: 48px;
                    .info_top_left{
                        .info_title{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 36px;
                            color: #333333;

                        }
                        .info_tages{
                            display: flex;
                            align-items: center;
                            padding-top: 20px;
                            .tages{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 24px;
                                color: #666666;

                            }
                            .borders{
                                width: 1px;
                                height: 20px;
                                background: #000000;
                                border-radius: 0px 0px 0px 0px;
                                opacity: 0.18;
                                margin: 0 19px;
                            }
                        }
                    }
                    .info_top_right{
                        .btns{
                            width: 268px;
                            height: 48px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 48px;
                            text-align: center;
                            font-family: SourceHanSansSC-Regular, SourceHanSansSC-Regular;
                            font-weight: normal;
                            font-size: 20px;
                            color: #FFFFFF;
                            cursor: pointer;
                        }
                    }
                }
                .info_bom{
                    padding-top: 40px;   
                    .info_bom_title{
                        font-family: SourceHanSansSC-Regular, SourceHanSansSC-Regular;
                        font-weight: normal;
                        font-size: 28px;
                        color: #333333;

                    }
                    .info_bom_const{
                        padding-top: 19px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #000B33;
                        line-height: 32px;
                        margin-bottom: 40px;
                    }
                     
                }
            }
         
            
        }
        .talent_acquisition_box2{
            width: 1440px;
            margin: auto;
            // margin-top: 56px;
            .box2_titles{
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                .title_borders{
                    width: 4px;
                    height: 40px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .title_text{
                    padding-left: 20px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 36px;
                    color: #333333;
                }
            }
            .box2_list{
                .list_item{
                    width: 1440px;
                    height: 240px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-bottom: 24px;
                    padding: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    .item_left{
                        width: 1000px;
                        .item_title{
                            margin-bottom: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #333333;

                        }
                        .item_tages{
                            display: flex;
                            align-items: center;
                            .tages{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #666666;
                            }
                            .borders{
                                width: 1px;
                                height: 16px;
                                background: #000000;
                                border-radius: 0px 0px 0px 0px;
                                opacity: 0.18;
                                margin: 0 20px;
                            }
                        }
                        .item_const{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #666666;
                            margin-top: 24px;
                        }
                    }
                    .item_right{
                        width: 64px;
                        height: 64px;
                        background: #FFFFFF;
                        border: 1px solid #E5E5E5;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 14px;
                        }
                    }
                    
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .talent_acquisition.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .talent_acquisition.no-trans .talent_acquisition1 {
        padding-bottom: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .title_box {
        padding-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .title_box .span1 {
        margin-right: 10px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .title_box .span2 {
        margin-left: 10px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .title_box img {
        margin-right: 10px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        padding: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .inof_top {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .inof_top .info_top_left .info_title {
        font-size: 24px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .inof_top .info_top_left .info_tages {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .inof_top .info_top_left .info_tages .tages {
        font-size: 24px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .inof_top .info_top_left .info_tages .borders {
        width: 1px;
        height: 20px;
        border-radius: 0px 0px 0px 0px;
        margin: 0 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .inof_top .info_top_right .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 20px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .info_bom {
        padding-top: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .info_bom .info_bom_title {
        font-size: 24px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box1 .info_box .info_bom .info_bom_const {
        padding-top: 16px;
        font-size: 16px;
        line-height: 32px;
        margin-bottom: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_titles {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_titles .title_borders {
        width: 4px;
        height: 40px;
        border-radius: 3px 3px 3px 3px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_titles .title_text {
        padding-left: 16px;
        font-size: 24px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 16px;
        padding: 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item .item_left {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item .item_left .item_title {
        margin-bottom: 16px;
        font-size: 24px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item .item_left .item_tages {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item .item_left .item_tages .tages {
        font-size: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item .item_left .item_tages .borders {
        width: 1px;
        height: 16px;
        border-radius: 0px 0px 0px 0px;
        margin: 0 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item .item_left .item_const {
        font-size: 16px;
        margin-top: 16px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item .item_right {
        width: 64px;
        height: auto;
        border-radius: 50%;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
    }
    .talent_acquisition.no-trans .talent_acquisition1 .talent_acquisition_box2 .box2_list .list_item .item_right img {
        width: 14px;
    }
}
</style>
